export var getDefaultStyleSheet = _ref => {
  var {
    hasNoLayoutCalculation,
    width
  } = _ref;
  return {
    rootStyle: hasNoLayoutCalculation ? {
      zIndex: 1
    } : {
      alignSelf: 'stretch',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width,
      zIndex: 1
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map